<template>
  <v-container v-if="user" fluid>
    <v-card>
      <v-card>
        <v-card-title class="text-center teal lighten-3 accent-4 white--text">
          Clientes
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Búsqueda"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-spacer />
          <v-btn color="primary" dark @click="dialogExcel = true">
            Subir Excel
          </v-btn>
        </v-card-title>

        <v-dialog v-model="dialogExcel" max-width="520">
          <v-card>
            <v-card-title class="headline">Subir Excel</v-card-title>
            <v-card-text>
              <v-file-input
                v-model="excelFile"
                accept=".xlsx, .xls"
                label="Selecciona un archivo Excel"
                prepend-icon="mdi-file-excel"
                dense
                show-size
                :disabled="loadingExcel"
              />
              <div v-if="loadingExcel" class="mt-4">
                <div class="d-flex justify-space-between align-center mb-2">
                  <span class="font-weight-bold">Subiendo...</span>
                  <span class="font-weight-bold"
                    >{{ uploadProgress.current }} de
                    {{ uploadProgress.total }}</span
                  >
                </div>
                <v-progress-linear
                  :value="(uploadProgress.current / uploadProgress.total) * 100"
                  color="primary"
                  height="8"
                />
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text @click="dialogExcel = false" :disabled="loadingExcel">
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                :disabled="!excelFile || loadingExcel"
                @click="submitExcelFile"
                :loading="loadingExcel"
              >
                Subir
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogResults" max-width="700">
          <v-card>
            <v-card-title class="headline">Resultados de la Carga</v-card-title>
            <v-card-text>
              <div class="mb-4">
                <v-chip color="green" text-color="white" class="mr-2">
                  Exitosos: {{ resultsData.successful.length }}
                </v-chip>
                <v-chip
                  v-if="resultsData.errors.length > 0"
                  color="red"
                  text-color="white"
                >
                  Errores: {{ resultsData.errors.length }}
                </v-chip>
              </div>

              <v-row class="mb-4">
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="showResultSuccessful"
                    label="Mostrar correctos"
                    color="green"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="showResultErrors"
                    label="Mostrar errores"
                    color="red"
                  />
                </v-col>
              </v-row>

              <v-data-table
                v-if="filteredResults.length"
                :headers="resultHeaders"
                :items="filteredResults"
                class="elevation-1"
                :items-per-page="15"
                :footer-props="{
                  'items-per-page-text': 'Resultados por página',
                }"
                :header-props="{
                  'sort-by-text': 'Ordenar por',
                }"
              >
                <template v-slot:[`item.state`]="{ item }">
                  <v-chip
                    :color="item.state === 'Correcto' ? 'green' : 'red'"
                    dark
                    small
                  >
                    {{ item.state }}
                  </v-chip>
                </template>
              </v-data-table>

              <div v-else class="text-center grey--text">
                No hay registros de resultado para mostrar.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="dialogResults = false">
                Cerrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div class="d-flex justify-end mr-4 mt-2">
          <v-btn
            small
            color="#ffff"
            elevation="5"
            class="mb-2"
            @click="exportToExcel"
            ><v-icon>mdi-microsoft-excel</v-icon
            ><v-icon>mdi-download</v-icon></v-btn
          >
        </div>

        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :items-per-page="15"
          :footer-props="{
            'items-per-page-text': 'Usuarios por página',
          }"
          :header-props="{
            'sort-by-text': 'Ordenar por',
          }"
        >
          <template v-slot:[`item.lista_de_precios`]="{ item }">
            {{ item.lista_de_precios[1] }}
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import ExcelJS from "exceljs";
import { mapGetters } from "vuex";
export default {
  components: {},

  data() {
    return {
      currentView: "OdooView",
      items: [],
      search: "",
      excelFile: null,
      dialogExcel: false,
      loadingExcel: false,
      uploadProgress: {
        current: 0,
        total: 0,
      },
      dialogResults: false,
      resultsData: {
        successful: [],
        errors: [],
      },
      resultsTable: [],
      showResultSuccessful: true,
      showResultErrors: true,
      resultHeaders: [
        { text: "ID de Cliente", value: "idCliente" },
        { text: "Campo", value: "campo" },
        { text: "Valor", value: "valor" },
        { text: "Estado", value: "state" },
      ],

      headers: [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Nombre",
          value: "nombre",
        },
        {
          text: "RFC",
          value: "rfc",
        },
        {
          text: "Codigo",
          value: "codigo",
        },
        {
          text: "Correo",
          value: "correo",
        },

        {
          text: "Domicilio",
          value: "domicilio",
        },
        {
          text: "Colonia",
          value: "colonia",
        },
        {
          text: "Ciudad",
          value: "ciudad",
        },
        {
          text: "Estado",
          value: "estado",
        },
        {
          text: "Código Postal",
          value: "cp",
        },
        {
          text: "Telefono",
          value: "telefono",
        },
        {
          text: "Lista de Precios",
          value: "lista_de_precios",
        },
        {
          text: "Posicion Fiscal",
          value: "posicion_fiscal",
        },
      ],
    };
  },
  methods: {
    async getClientesOdoo() {
      try {
        const clientes = await axios.get("/odoo/get_clientes");

        const headers = clientes.data.headers;
        const rows = clientes.data.data;

        this.items = rows.map((row) => {
          let obj = {};
          headers.forEach((header, index) => {
            obj[header] = row[index];
          });
          return obj;
        });
      } catch (error) {
        console.error(error);
      }
    },

    submitExcelFile() {
      if (!this.excelFile) {
        console.warn("Selecciona un archivo antes de subir.");
        return;
      }
      this.uploadExcelFile(this.excelFile);
    },

    async uploadExcelFile(file) {
      this.loadingExcel = true;
      try {
        const workbook = new ExcelJS.Workbook();
        const arrayBuffer = await file.arrayBuffer();
        await workbook.xlsx.load(arrayBuffer);

        const worksheet = workbook.worksheets[0];
        if (!worksheet) {
          throw new Error("El archivo Excel no tiene ninguna hoja.");
        }

        const headerRow = worksheet.getRow(1);
        const headers = headerRow.values
          .slice(1)
          .map((value) => String(value || "").trim());
        if (headers.length < 2) {
          throw new Error(
            "El Excel debe tener al menos columna de producto y una columna de valor.",
          );
        }

        /*const productByCode = this.items.reduce((map, item) => {
          const code = String(item.codigo_prod || "").trim();
          if (code) {1
            map[code] = item.id;
          }
          return map;
        }, {});*/

        const clienteById = this.items.reduce((map, item) => {
          map[item.id] = item;
          return map;
        }, {});

        const requests = [];
        const requestMetadata = [];
        let missingClientes = 0;

        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber === 1) {
            return;
          }

          const rowValues = row.values
            .slice(1)
            .map((value) =>
              value === undefined || value === null ? "" : value,
            );
          //const productCode = String(rowValues[0] || "").trim();
          const idCliente = clienteById[rowValues[0]]
            ? clienteById[rowValues[0]].id
            : null;

          if (!idCliente) {
            missingClientes += 1;
            return;
          }

          for (
            let columnIndex = 1;
            columnIndex < headers.length;
            columnIndex += 1
          ) {
            const campo = headers[columnIndex];
            const valor = rowValues[columnIndex];
            if (valor === "" || valor === null || valor === undefined) {
              continue;
            }

            const metadata = { idCliente, campo, valor };
            requestMetadata.push(metadata);
            requests.push(
              axios
                .post(
                  `/odoo/actualizar_cliente?id_cliente=${idCliente}&campo=${campo}&valor=${valor}`,
                )
                .then(() => {
                  this.uploadProgress.current += 1;
                }),
            );
          }
        });

        if (requests.length === 0) {
          console.warn(
            "No se encontraron valores para enviar en el archivo Excel.",
          );
          return;
        }

        this.uploadProgress.total = requests.length;
        this.uploadProgress.current = 0;

        const results = await Promise.allSettled(requests);
        this.resultsData = { successful: [], errors: [] };
        this.resultsTable = [];

        results.forEach((result, index) => {
          const metadata = requestMetadata[index];
          if (result.status === "fulfilled") {
            const row = { ...metadata, state: "Correcto" };
            this.resultsData.successful.push(metadata);
            this.resultsTable.push(row);
          } else {
            const row = {
              ...metadata,
              state: "Error",
              message: result.reason?.message || "Error desconocido",
            };
            this.resultsData.errors.push(row);
            this.resultsTable.push(row);
          }
        });

        console.info(
          `Excel procesado: ${this.resultsData.successful.length} exitosos, ${this.resultsData.errors.length} errores, ${missingClientes} filas sin clientes válido.`,
        );
      } catch (error) {
        console.error("Error al procesar el Excel:", error);
      } finally {
        this.excelFile = null;
        this.loadingExcel = false;
        this.uploadProgress = { current: 0, total: 0 };
        this.dialogExcel = false;
        this.dialogResults = true;
        await this.getClientesOdoo();
      }
    },

    async exportToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Clientes");
      worksheet.columns = this.headers.map((header) => ({
        header: header.text,
        key: header.value,
        width: 20,
      }));

      this.items.forEach((item) => {
        worksheet.addRow(item);
      });
      worksheet.getRow(1).font = { bold: true };
      worksheet.getRow(1).alignment = { horizontal: "center" };
      worksheet.getRow(1).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFB0BEC5" },
        };
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Clientes.xlsx";
        link.click();
        URL.revokeObjectURL(url);
      });
    },
    getColor(estado) {
      return estado ? "green" : "red";
    },

    formatearCosto(costo) {
      const moneda = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      });
      return moneda.format(costo);
    },
  },
  created() {
    this.getClientesOdoo();
  },
  computed: {
    ...mapGetters(["user"]),
    filteredResults() {
      return this.resultsTable.filter((item) => {
        if (item.state === "Correcto" && this.showResultSuccessful) {
          return true;
        }
        if (item.state === "Error" && this.showResultErrors) {
          return true;
        }
        return false;
      });
    },
  },
};
</script>
